<div class="row">
    <div class="col-12">
        <ng-container *ngIf="loading">
            <ngx-skeleton-loader [theme]="{
                height: '200px',
                width: '100%',
                margin: '0'
            }"></ngx-skeleton-loader>
        </ng-container>

        <div class="dash-details-card papers-card" *ngIf="!loading">
            <div class="dash-details-card-header">
                <span>Transferências</span>
            </div>
            <app-spacer [bottom]="16"></app-spacer>

            <ng-container *ngIf="!transfers.length">
                <div class="dash-details-card-body"
                    style="padding: 48px 20px; min-height: 160px;">
                    <app-empty-content [isVisible]="true"
                        title="Nenhuma transferência encontrada"
                        description="Não foi encontrado nenhum registro de transferência para este fundo."
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>
                </div>
            </ng-container>

            <ng-container *ngIf="transfers.length">
                <div class="table-container papers-table-container">
                    <table class="papers-data-table">
                        <thead>
                            <tr>
                                <th>Tipo</th>
                                <th>Data de transferência</th>
                                <th>Data da assembleia</th>
                                <th>Motivo</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container
                                *ngFor="let transfer of transfers; let i = index">
                                <tr>
                                    <td>
                                        <div class="paper-cell-with-toggle">
                                            <button type="button"
                                                class="paper-reason-toggle"
                                                *ngIf="canExpand(transfer)"
                                                (click)="toggleTransferHistory(i)"
                                                [attr.aria-label]="isTransferExpanded(i) ? 'Ocultar detalhes' : 'Exibir detalhes'"
                                                [title]="isTransferExpanded(i) ? 'Ocultar detalhes' : 'Exibir detalhes'">
                                                <svg-icon
                                                    src="assets/images/icon-right.svg"
                                                    class="paper-reason-toggle-icon"
                                                    [class.expanded]="isTransferExpanded(i)">
                                                </svg-icon>
                                            </button>
                                            <span>{{ transfer.type }}</span>
                                        </div>
                                    </td>
                                    <td>{{ transfer.transferDate }}</td>
                                    <td>{{ transfer.assemblyDate }}</td>
                                    <td>{{ transfer.reason }}</td>
                                    <td class="transfer-edit-cell">
                                        <div class="transfer-row-actions"
                                            *ngIf="hasRowActions(transfer)">
                                            <app-tooltip
                                                *ngIf="canEditTransfer(transfer)"
                                                text="Editar agendamento"
                                                position="top">
                                                <button type="button"
                                                    class="dash-item-button"
                                                    (click)="editTransfer(i, $event)"
                                                    aria-label="Editar agendamento">
                                                    <svg-icon
                                                        src="assets/images/icon-edit.svg">
                                                    </svg-icon>
                                                </button>
                                            </app-tooltip>
                                            <app-tooltip
                                                *ngIf="canCancelTransfer(transfer)"
                                                text="Cancelar agendamento"
                                                position="top">
                                                <button type="button"
                                                    class="dash-item-button"
                                                    (click)="cancelTransfer(i, $event)"
                                                    aria-label="Cancelar agendamento">
                                                    <svg-icon
                                                        src="assets/images/icon-ban.svg">
                                                    </svg-icon>
                                                </button>
                                            </app-tooltip>
                                            <app-tooltip
                                                *ngIf="canConfirmInactivation(transfer)"
                                                text="Confirmar inativação"
                                                position="top">
                                                <button type="button"
                                                    class="dash-item-button"
                                                    (click)="confirmTransfer(i, $event)"
                                                    aria-label="Confirmar inativação">
                                                    <svg-icon
                                                        src="assets/images/icon-check.svg">
                                                    </svg-icon>
                                                </button>
                                            </app-tooltip>
                                        </div>
                                    </td>
                                </tr>

                                <tr class="paper-reason-row"
                                    *ngIf="canExpand(transfer) && isTransferExpanded(i)">
                                    <td colspan="5">
                                        <div class="paper-reason-content transfer-admin-details">
                                            <ng-container
                                                *ngIf="transfer.hasAdministratorFields">
                                                <div class="row">
                                                    <div class="col-6 d-flex flex-column">
                                                        <span
                                                            class="dash-details-card-item-subtitle">
                                                            Razão social
                                                        </span>
                                                        <span
                                                            class="dash-details-card-item-title">
                                                            {{ transfer.administrator.razaoSocial }}
                                                        </span>
                                                    </div>
                                                    <div class="col-6 d-flex flex-column">
                                                        <span
                                                            class="dash-details-card-item-subtitle">
                                                            CNPJ
                                                        </span>
                                                        <span
                                                            class="dash-details-card-item-title">
                                                            {{ transfer.administrator.cnpj }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <app-spacer [bottom]="16"></app-spacer>

                                                <div class="row">
                                                    <div class="col-6 d-flex flex-column">
                                                        <span
                                                            class="dash-details-card-item-subtitle">
                                                            Contato
                                                        </span>
                                                        <span
                                                            class="dash-details-card-item-title">
                                                            {{ transfer.administrator.contato }}
                                                        </span>
                                                    </div>
                                                    <div class="col-6 d-flex flex-column">
                                                        <span
                                                            class="dash-details-card-item-subtitle">
                                                            E-mail
                                                        </span>
                                                        <span
                                                            class="dash-details-card-item-title">
                                                            {{ transfer.administrator.email }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <app-spacer [bottom]="16"></app-spacer>

                                                <div class="row">
                                                    <div class="col-6 d-flex flex-column">
                                                        <span
                                                            class="dash-details-card-item-subtitle">
                                                            Telefone
                                                        </span>
                                                        <span
                                                            class="dash-details-card-item-title">
                                                            {{ transfer.administrator.telefone }}
                                                        </span>
                                                    </div>
                                                    <div class="col-6 d-flex flex-column">
                                                        <span
                                                            class="dash-details-card-item-subtitle">
                                                            Celular
                                                        </span>
                                                        <span
                                                            class="dash-details-card-item-title">
                                                            {{ transfer.administrator.celular }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </ng-container>

                                            <ng-container
                                                *ngIf="!transfer.hasAdministratorFields">
                                                <span class="paper-reason-label">Observação:</span>
                                                <span>{{ transfer.observation }}</span>
                                            </ng-container>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </ng-container>
        </div>
        <app-spacer [bottom]="24"></app-spacer>
    </div>
</div>
